import { useMedia } from "use-media";
import { media } from "@nju/css";
import { IInvoice } from "@nju/data-access-portal-payment";
import { Desktop, Mobile } from "./partials";

interface IInvoiceHistoryRowProps {
  invoice: IInvoice;
  onInvoiceSend: (id: string) => void;
  isLastRow: boolean;
}

export function InvoiceHistoryRow({
  invoice,
  onInvoiceSend,
  isLastRow,
}: IInvoiceHistoryRowProps) {
  const isMobile = useMedia(media.onlyMobile);

  return (
    <>
      {isMobile && (
        <Mobile
          invoice={invoice}
          isLastRow={isLastRow}
          onInvoiceSend={onInvoiceSend}
        />
      )}
      {!isMobile && <Desktop invoice={invoice} onInvoiceSend={onInvoiceSend} />}
    </>
  );
}
